import React from 'react'
import { withRouter } from "react-router-dom";
import Addmoveform from './componennts/Addmoveform'
function Addmovesize() {
    return (
       <Addmoveform></Addmoveform>
    )
}
export default  withRouter(Addmovesize);
